exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ContextMenuItemContent___2tDzo {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.5rem;\n}\n", ""]);

// exports
exports.locals = {
	"ContextMenuItemContent": "ContextMenuItemContent___2tDzo"
};